<template>
  <div class="contract-chart">
    <div class="contract-table">
      <sirui-table
        ref="siruiTable"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :showToolbar="false"
        height="300"
        :cellStyle="cellStyle"
        :cellClick="cellClick"
        :columns="getChartColumns"
        @handleSizeChange="() => getData()"
        @handleCurrentChange="() => getData()"
      >
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in getChartColumns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
        >
          <template slot-scope="scope">
            <span v-if="item.field == 'contractType'">{{
              getContractType(scope.row[item.field])
            }}</span>
            <span
              v-else-if="
                item.field == 'contractSignDate' ||
                item.field == 'contractEffectDate' ||
                item.field == 'contractExpireDate'
              "
            >
              {{ formatDateCustom(scope.row[item.field], false) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  // import BASEAPI from '@/api/dataBase.js';
  import { chartColumns } from './index.js';
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  export default {
    name: 'AssoContractChart',
    mixins: [IntermodalityCommonMixin],
    props: {
      //customer or supplier
      chartType: {
        type: String,
        default: () => 'customer',
      },
      projectCode: {
        type: String,
        default: () => '',
      },
      // baseFormData: {
      //   type: Object,
      //   require: true,
      // },
    },
    data() {
      return {
        loading: false,
        tableData: [],
      };
    },
    mounted() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
    },
    methods: {
      cellClick(val) {
        if (val.column?.property == 'contractCode') {
          console.log('clickContract', val);
          let isCustomerContract = this.chartType == 'customer';
          let code = val.row.contractCode;
          this.toContractDetail(code, isCustomerContract);
        }
      },
      cellStyle({ row, rowIndex, column, columnIndex }) {
        if (column.property == 'contractCode') {
          console.log('cellStyle', row, rowIndex, column, columnIndex);
          return {
            color: '#009fcc',
            cursor: 'pointer',
          };
        }
      },
      getContractType(type) {
        if (type == 0) {
          return '常规合同';
        } else if (type == 1) {
          return '结算条款';
        }
        return type;
      },
      toContractDetail(contractCode, isCustomerContract) {
        let suffix = '';
        let name = '';
        let query = { contractCode, origin: 'detail', pageMode: 1 };

        if (isCustomerContract) {
          suffix = 'customerContractDetail';
          name = '客方合同详情';
        } else {
          suffix = 'supplierContractDetail';
          name = '供方合同详情';
        }

        let path = {
          path: '/intermodality/' + suffix,
          name: suffix,
          meta: {
            keepAlive: true,
            title: name,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      async getData() {
        if (!this.projectCode || !this.projectCode.length) {
          return;
        }
        let params = {
          projectCode: this.projectCode,
          isCS: this.chartType == 'customer' ? 'C' : 'S',
        };
        params.pageNum = this.$refs.siruiTable?.page?.pageNum;
        params.pageSize = this.$refs.siruiTable?.page?.pageSize;
        let data = await this.getContractList(params);
        if (data && data.data.data && data.data.data.list.length) {
          this.tableData = data.data.data.list || [];
          if (this.tableData.length != 0) {
            this.$emit('assoChanged', this.chartType, this.tableData);
          }
          this.$refs.siruiTable.setPageTotal(data.data.data.total);
          this.$refs.siruiTable.setPageSize(data.data.data.size);
        }
      },
    },
    watch: {
      projectCode: {
        handler(newVal, oldVal) {
          console.log(newVal, oldVal);
          if (newVal && newVal.length && newVal != oldVal) {
            this.getData(newVal);
          }
        },
        deep: true,
        immediate: true,
      },
    },
    computed: {
      getChartColumns() {
        if (this.chartType == 'supplier') {
          return chartColumns.map((item) => {
            if (item.field === 'customerName') {
              return {
                field: 'supplierName',
                title: '供方名称',
                width: '140',
              };
            }
            return item;
          });
        } else {
          return chartColumns;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .contract-chart {
    background: #fff;

    .contract-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
